import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  getOffset,
  getIsNewPage,
  getIsLoading,
  getIsLoadingPrevious,
  getShowLoadMore,
  getShowLoadPrevious,
  getTileToFocus
} from "../../../../state/modules/search/selectors";
import { getPages } from "../../../../state/modules/search/__variants__/plp-promo-tile/selectors";
import { getCategoryId } from "../../../../state/modules/category";
import { getViewportCategory } from "../../../../state/modules/layout/selectors";
import { isErrorOfTypeServer as getIsErrorOfTypeServer } from "../../../../state/modules/error";
import { Results } from "../../../Results/Results";
import {
  getFloor,
  getStoreCode
} from "../../../../state/modules/config/selectors";
import getPromoTilePosition from "./getPromoTilePosition";
import shouldShowPromoTile from "./shouldShowPromoTile";

const ConnectedResults = props => {
  const pages = useSelector(getPages);
  const offset = useSelector(getOffset);
  const isErrorOfTypeServer = useSelector(getIsErrorOfTypeServer);
  const isNewPage = useSelector(getIsNewPage);
  const isLoading = useSelector(getIsLoading);
  const isLoadingPrevious = useSelector(getIsLoadingPrevious);
  const showLoadMore = useSelector(getShowLoadMore);
  const showLoadPrevious = useSelector(getShowLoadPrevious);
  const tileToFocus = useSelector(getTileToFocus);
  const viewportCategory = useSelector(getViewportCategory);
  const categoryId = useSelector(getCategoryId);
  const storeCode = useSelector(getStoreCode);
  const floor = useSelector(getFloor);

  const promoTilePosition = getPromoTilePosition({ viewportCategory });

  const { PromoTile } = props;

  const promoTile = shouldShowPromoTile({
    floor,
    storeCode,
    categoryId,
    pages
  })
    ? {
        component: (
          <PromoTile
            storeCode={storeCode}
            floor={floor}
            viewportCategory={viewportCategory}
          />
        ),
        position: promoTilePosition
      }
    : null;

  return (
    <Results
      {...{
        ...props,
        pages,
        isErrorOfTypeServer,
        isLoading,
        isNewPage,
        isLoadingPrevious,
        showLoadMore,
        showLoadPrevious,
        tileToFocus,
        offset,
        promoTile
      }}
    />
  );
};

ConnectedResults.propTypes = {
  PromoTile: PropTypes.elementType
};

export default ConnectedResults;
